export const DEFAULT_ACTION = 'app/MakePaymentPage/DEFAULT_ACTION';
